import { useTranslation } from "react-i18next";
import CalendarScheduleSlotModel from "../../models/CalendarScheduleSlotModel";
import SlotTime from "./SlotTime";

export default function CompactSlotTitle({
  slot,
}: {
  slot: CalendarScheduleSlotModel;
}) {
  const { t } = useTranslation("", {
    keyPrefix: "page.sessionInfo",
  });

  if (slot?.scheduleSlotType === "reading") {
    return (
      <span className="truncate" title={slot.startTime.format("hh:mm A")}>
        {t("sessionRate")}
      </span>
    );
  } else if (!!slot.student?.firstName)
    return (
      <span className="truncate" title={slot.startTime.format("hh:mm A")}>
        {slot?.student?.name}
      </span>
    );
  return <SlotTime time={slot.startTime} />;
}
